// extracted by mini-css-extract-plugin
export default {"contentWrapper":"LoanRepaymentScheduleForm_contentWrapper__2SKAz","loader":"LoanRepaymentScheduleForm_loader__gzRcT"};